import * as React from "react";
import { cn } from "@/lib/utils";
import { Button, type ButtonProps } from "./Button";

const squares = { sm: "w-9 px-0", md: "w-11 px-0", lg: "w-14 px-0" } as const;

export interface IconButtonProps extends Omit<ButtonProps, "leftIcon" | "rightIcon" | "fullWidth"> {
  /** Accessible name, also shown as the native tooltip. Required: the button has no text. */
  label: string;
  /** Fully round instead of the standard radius. */
  round?: boolean;
}

/** Square button holding a single icon. Defaults to the "ghost" variant. */
export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ label, round = false, variant = "ghost", size = "md", className, title, ...props }, ref) => (
    <Button
      ref={ref}
      variant={variant}
      size={size}
      aria-label={label}
      title={title ?? label}
      className={cn(squares[size], round && "rounded-full", className)}
      {...props}
    />
  ),
);
IconButton.displayName = "IconButton";
